
import React, { useEffect, useMemo, useRef, useState } from 'react';
import dateformat from "dateformat";
import numeral from "numeral";

import { DealRoomsContext } from '../../index';

import Thumbnail from 'src/components/thumbnail';
import  Tooltip  from 'src/components/tooltip';

import { DealRoom } from 'src/types/dealRoom';

import _ from 'lodash';
import cx from 'classnames';
import styles from './styles.module.scss';
import Truncate from 'src/components/truncate';
import pluralize from 'pluralize';
import { useSelector } from "react-redux";



interface DealRoomCardProps {
  item: DealRoom;
  selected?: boolean | null | undefined;
  onEditChanges?: (value: any) => void;
  readonly?: boolean;
  onClick?: (collection: DealRoom) => void;
  isFirstCard?: boolean;
  showDealInfo?: boolean;
}

export const DealRoomCard: React.FC<DealRoomCardProps> = ({ isFirstCard, item, selected, onEditChanges, readonly, onClick, showDealInfo = true }) => {

  const { editMode } = React.useContext(DealRoomsContext);
  const isRenaming = editMode === "rename";
  const isDeleting = editMode === "delete"
  const isCloning = editMode === "clone"
  const selection = _.includes(['clone', 'delete', 'selection'], editMode);

  const [updatedName, setUpdatedName] = React.useState(item.name);


  const name = _.get(item, 'name', '');
  const icon = _.get(item, 'banner.background');
  const modifiedDate = _.get(item, 'modifiedDate', "");
  const isTemplate = _.get(item, 'template', false);

  const disabled = useMemo(() => {
    if (readonly) {
      return true;
    }

    if (isRenaming) {
      return !item.canEdit;
    }

    if (editMode === 'delete') {
      return !item.creator;
    }

    return false;
  }, [editMode, isRenaming, item]);


  const handleClick = (e) => {
    e.preventDefault();
    if (selection && !disabled) {
      if (onEditChanges) {
        onEditChanges({
          id: item.id,
          type: 'dealRoom',
          value: selected ? null : item
        });
      }
    }
    if (isRenaming) {
      if (onEditChanges) {
        onEditChanges({
          id: item.id,
          type: 'dealRoom',
          value: selected ? null : item
        });
      }
    } else if (onClick && !selection) {
      onClick(item);
    }
  }

  const handleRename = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUpdatedName(e.target.value);
    if (onEditChanges) {
      onEditChanges({
        id: item.id,
        type: 'dealRoom',
        value: e.target.value,
        oldName: item.name
      });
    }
  }

  const isDealMapped = _.size(item?.stageValue) > 0 ;

  const notifications = [
    "Elizabeth has viewed the asset “Meet New Paperflite 2025”, on 22 Jan",
    "You've got 3 new messages",
    "You've 3 external participants joined recently to this room"
  ]

  const [index, setIndex] = useState(0);
  const divRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isRenaming) {
      setUpdatedName(item.name);
    }
  }, [isRenaming]);

  useEffect(() => {
    if (divRef.current) {
      divRef.current.scrollTo({
        top: index * 32,
        behavior: 'smooth'
      });
    }
  }, [index])

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIndex(prevIndex => {
        if (prevIndex === notifications.length - 1) {
          return 0;
        }
        return prevIndex + 1;
      });
    }, 2000);

    return () => clearInterval(intervalId);
  }, []);

  const showContents = !isRenaming
const currency = useSelector((state: any) =>
  _.get(state, "accounts.item.currency", "$")
);
  return (
    <div className={cx(styles.card, {
      [styles.firstCard]: isFirstCard,
      [styles.deleting]: isDeleting,
      [styles.selected]: selected,
      [styles.readonly]: readonly,
      [styles.disabled]: disabled,
      [styles.renaming]: isRenaming,
    })} onClick={handleClick}>

      {isTemplate && <div className={styles.indicators}>
        <Tooltip content={'Deal Room Template'} placement='right'>
          <i className="paperflite-template"></i>
        </Tooltip>
      </div>}
      
    
    {/* 
      {!isFirstCard && showContents && <div className={styles.notification}>
        <p> <i className={"paperflite-add"} /> New people added </p>
      </div>} */}

        <Thumbnail className={cx(styles.icon,styles.iconContainer)}
          defaultImage='/images/collections/background.jpeg'
          media={icon} />

      <div className={styles.content}>
        <p className={cx(styles.name, {
          [styles.disabled]: isDeleting && disabled,
        })}>
          {isRenaming && !disabled ? <input type='text' value={updatedName} onChange={handleRename} className={cx(styles.input)} />
            : <Truncate width={180}> {name} </Truncate>}

          {_.get(item,"amount", 0) > 0 && showContents && showDealInfo && <span className={styles.dealValue}>{`${currency}${_.get(item, 'amount')}`}</span>}

        </p>

        {showDealInfo && showContents && <div className={styles.details}>
          <div>
            <p className={styles.subText}>
            <Truncate width={200} lines={1}>
                {item?.totalPeopleInvolved} {pluralize("stakeholder", item?.totalPeopleInvolved )} involved
              </Truncate>
            </p>
            <p className={styles.subText}>
              <Truncate width={200} lines={1}>
                deal stage: { _.size(item?.stageValue) > 0 ? item?.stageValue : "--/--" }
              </Truncate>
            </p>
            <p className={styles.subText}>
              <Truncate width={200} lines={1}>
                last updated on {dateformat(modifiedDate, "dd mmm yyyy")}
              </Truncate>
            </p>
          </div>

          {isDealMapped && <div className={styles.winProb}>
            <p>win prob:<br /> <span className={styles.percentage}>{`${numeral(_.get(item,"winProbability",0)).format("(0)")}%`}</span></p>
          </div>}
        </div>} 

        {!editMode && !isFirstCard && <i className={cx("paperflite-right-arrow", styles.arrow)}></i>}

        {(isDeleting || isCloning) && !disabled && <i className={cx(styles.select, selected ? "fa-solid fa-check-circle" : "paperflite-radio-button-unselected")} />}
      </div>

      {/* {isFirstCard && showContents && <div
        ref={divRef}
        className={styles.cardFooter}>
        {notifications.map((notification, index) => (
          <div key={index} className={styles.notificationsContainer}>
            <p className={styles.title}>{notification}

            <div className={styles.people}>
                {_.times(3, (index) => (
                  <div className={styles.avatar}>
                    <img src={"https://plus.unsplash.com/premium_photo-1689551670902-19b441a6afde?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8cmFuZG9tJTIwcGVvcGxlfGVufDB8fDB8fHww"} />
                  </div>
                ))}
              </div>
            </p>
            <p className={styles.view}> <i className='paperflite-right-arrow' />
            
              more details</p>
          </div>
        ))}
      </div>} */}

    </div>
  )
}

export const PlaceholderDealRoomCard = ({ isFirstCard }) => {
  return (
    <div className={cx(styles.placeholder, {
      [styles.firstCard]: isFirstCard
    })}>
      <div className={cx(styles.icon, styles.block,{
        [styles.firstCardIcon]: isFirstCard
      })}></div>
      <div className={styles.cardContent}>
        <div className={styles.details}>
          <div className={cx(styles.name, styles.block)}></div>
          <p className={cx(styles.date, styles.block)}></p>
          <p className={cx(styles.date, styles.block)}></p>
          <p className={cx(styles.date, styles.block)}></p>
        </div>
      </div>
    </div>
  );
}

interface DeleteDealRoomCardProps {
  dealRoom: DealRoom;
}

export const DeleteDealRoomCard: React.FC<DeleteDealRoomCardProps> = ({ dealRoom }) => {
  const name = _.get(dealRoom, 'name', '');
  const icon = _.get(dealRoom, 'banner.background');

  return (  
    <div className={cx(styles.card, styles.delete)}>
      <div className={styles.iconContainer}>
        <Thumbnail className={styles.icon}
          defaultImage='/images/collections/background.jpeg'
          media={icon} />
      </div>

      <div className={styles.content}>
        <p className={styles.name}>
          <Truncate width={180}>{name}</Truncate>
        </p>
        {dealRoom.stageValue != null && <p className={styles.dealStage}>
          <Truncate width={200}>{`${_.get(dealRoom, 'stageValue', '')}`}</Truncate>
          </p>}
      </div>
    </div>
  )
}


interface CloneDealRoomCardProps {
  dealRoom: DealRoom;
}
export const CloneDealRoomCard: React.FC<CloneDealRoomCardProps> = ({ dealRoom }) => {
  const name = _.get(dealRoom, 'name', '');
  const icon = _.get(dealRoom, 'banner.background');

  return (  
    <div className={cx(styles.card, styles.clone)}>
      <div className={styles.iconContainer}>
        <Thumbnail className={styles.icon}
          defaultImage='/images/collections/background.jpeg'
          media={icon} />
      </div>
      <div className={styles.content}>
        <div className={styles.dealRoomName}>
          <Tooltip placement="top" className={styles.name} content={name}>
            <span className={styles.name}>
          <Truncate width={180}>{name}</Truncate>
          </span>
          </Tooltip>
        </div>
        {dealRoom.stageValue != null && <p className={styles.dealStage}>
          <Tooltip placement="top" className={styles.name} content={`${_.get(dealRoom, 'stageValue', '')}`}>
            <span className={styles.name}>
              <Truncate width={180}>{`${_.get(dealRoom, 'stageValue', '')}`}</Truncate>
            </span>
          </Tooltip></p>}
      </div>
    </div>
  )
}